export default {
  path: '/trackers/tracker-firmware-versions',
  name: 'TrackerFirmwareVersions',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerFirmwareVersionsView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
